export const generatedCandidateSbdbRefreshManifest = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-30T00:00:00.000Z",
  "mode": "deterministic-candidate-sbdb-refresh-manifest",
  "operatingRule": "This manifest tracks candidate-specific CAD and SBDB source payload readiness for the current capture. It is a refresh and draft-intake worklist, not source custody, resource evidence, or customer-use clearance.",
  "sourceCapturePath": "evidence/source-candidate-payloads/small-body-live-capture-current.json",
  "sourceCaptureHash": "sha256-2ad162480cc48a0874105a289f1df9732e325c92f043f7f9d1ba379bb8f37d98",
  "workOrderCount": 10,
  "cadRecordCount": 10,
  "sbdbRecordCount": 10,
  "missingSbdbCount": 0,
  "missingCadCount": 0,
  "readyDraftCount": 10,
  "allWorkOrdersHaveCad": true,
  "allWorkOrdersHaveSbdb": true,
  "sourceCustodyPromotionAllowed": false,
  "resourcePromotionAllowed": false,
  "customerUseAllowed": false,
  "recommendedRefreshCommand": "npm run science:smallbody:capture -- --limit 10 --sbdb-limit 10 --out evidence/source-candidate-payloads/small-body-live-capture-current.json",
  "postRefreshCommandSequence": [
    "npm run science:smallbody:workorder-drafts",
    "npm run science:smallbody:source-promotion",
    "npm run science:smallbody:closure-packets",
    "npm run science:smallbody:review-docket",
    "npm run science:report"
  ],
  "blockers": [
    "MPC bridge, source-use review, human reviewer approval, and composition evidence remain separate gates after SBDB refresh."
  ],
  "items": [
    {
      "workOrderId": "small-body-source-work-order-2026-jm2",
      "sourceCandidateId": "cad-2026 JM2",
      "designation": "2026 JM2",
      "queueRank": 1,
      "reviewPriorityScore": 52.39,
      "sourceState": "draft-intake-source-ready",
      "hasCadRecord": true,
      "hasSbdbRecord": true,
      "cadRecordHash": "sha256-1d8b572b7e3195249e0b0f7b40ebf6b94fa322c3d905693012109e0c15399ae4",
      "sbdbUrl": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+JM2&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
      "cadUrl": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+JM2&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
      "expectedPayloadPath": "evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
      "expectedReportPath": "evidence/source-candidate-reports/2026-jm2-source-intake-report.json",
      "nextAction": "Generate or review candidate source draft intake; MPC, source-use, reviewer, and composition gates still remain closed.",
      "promotionBoundary": "SBDB refresh supports source-custody intake only. It does not prove composition, resource class, economics, or customer-use clearance.",
      "refreshItemHash": "sha256-da908be4c00dc22deb1bb1d8bd8a239c490d65c709137ba1b5043b5cbdb3e54f"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-em",
      "sourceCandidateId": "cad-2026 EM",
      "designation": "2026 EM",
      "queueRank": 2,
      "reviewPriorityScore": 44.28,
      "sourceState": "draft-intake-source-ready",
      "hasCadRecord": true,
      "hasSbdbRecord": true,
      "cadRecordHash": "sha256-a4fcc74ac2d34ceaa0ca5bd0f5f13d28a8e1acb583b2b8e0987ee224e14ccea0",
      "sbdbUrl": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+EM&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
      "cadUrl": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+EM&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
      "expectedPayloadPath": "evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
      "expectedReportPath": "evidence/source-candidate-reports/2026-em-source-intake-report.json",
      "nextAction": "Generate or review candidate source draft intake; MPC, source-use, reviewer, and composition gates still remain closed.",
      "promotionBoundary": "SBDB refresh supports source-custody intake only. It does not prove composition, resource class, economics, or customer-use clearance.",
      "refreshItemHash": "sha256-5ed0792b7fd453a48139a4f8c3f830b8c6351ec1f932c3184c25f9fe4a7f6656"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-dn5",
      "sourceCandidateId": "cad-2026 DN5",
      "designation": "2026 DN5",
      "queueRank": 3,
      "reviewPriorityScore": 39.5,
      "sourceState": "draft-intake-source-ready",
      "hasCadRecord": true,
      "hasSbdbRecord": true,
      "cadRecordHash": "sha256-76ae53798c879a4202cf35d33d562b8c27936d625ded63d43245632913192744",
      "sbdbUrl": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+DN5&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
      "cadUrl": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+DN5&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
      "expectedPayloadPath": "evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
      "expectedReportPath": "evidence/source-candidate-reports/2026-dn5-source-intake-report.json",
      "nextAction": "Generate or review candidate source draft intake; MPC, source-use, reviewer, and composition gates still remain closed.",
      "promotionBoundary": "SBDB refresh supports source-custody intake only. It does not prove composition, resource class, economics, or customer-use clearance.",
      "refreshItemHash": "sha256-448924c59adc5de6351f6cbe19f1d7c742f0f562d96e7e39b45f26da46f5eaca"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-lx",
      "sourceCandidateId": "cad-2026 LX",
      "designation": "2026 LX",
      "queueRank": 4,
      "reviewPriorityScore": 39.44,
      "sourceState": "draft-intake-source-ready",
      "hasCadRecord": true,
      "hasSbdbRecord": true,
      "cadRecordHash": "sha256-ac95fa658e8f5095898f1e8b99c8f5772e9b3f99c606b173ed195032e697c33c",
      "sbdbUrl": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+LX&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
      "cadUrl": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+LX&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
      "expectedPayloadPath": "evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
      "expectedReportPath": "evidence/source-candidate-reports/2026-lx-source-intake-report.json",
      "nextAction": "Generate or review candidate source draft intake; MPC, source-use, reviewer, and composition gates still remain closed.",
      "promotionBoundary": "SBDB refresh supports source-custody intake only. It does not prove composition, resource class, economics, or customer-use clearance.",
      "refreshItemHash": "sha256-9978090ecdba806708876e0003e87ebc49570ee646c8cdada11698642c50b705"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-ku1",
      "sourceCandidateId": "cad-2026 KU1",
      "designation": "2026 KU1",
      "queueRank": 5,
      "reviewPriorityScore": 36.59,
      "sourceState": "draft-intake-source-ready",
      "hasCadRecord": true,
      "hasSbdbRecord": true,
      "cadRecordHash": "sha256-ab85951bf0b5937b82e4897bec84ac8b6960984b7d25f0aa9513c1650ff285ff",
      "sbdbUrl": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+KU1&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
      "cadUrl": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+KU1&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
      "expectedPayloadPath": "evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
      "expectedReportPath": "evidence/source-candidate-reports/2026-ku1-source-intake-report.json",
      "nextAction": "Generate or review candidate source draft intake; MPC, source-use, reviewer, and composition gates still remain closed.",
      "promotionBoundary": "SBDB refresh supports source-custody intake only. It does not prove composition, resource class, economics, or customer-use clearance.",
      "refreshItemHash": "sha256-8d2644d8936dcdf6395414ac6022dc3a139ed543915da604806774ef1e36333a"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-fs5",
      "sourceCandidateId": "cad-2026 FS5",
      "designation": "2026 FS5",
      "queueRank": 6,
      "reviewPriorityScore": 30.19,
      "sourceState": "draft-intake-source-ready",
      "hasCadRecord": true,
      "hasSbdbRecord": true,
      "cadRecordHash": "sha256-3b4056c8a9bb136861866fbae2026dcd81a7dbcac27eb3739db29177e6eddc56",
      "sbdbUrl": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+FS5&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
      "cadUrl": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+FS5&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
      "expectedPayloadPath": "evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
      "expectedReportPath": "evidence/source-candidate-reports/2026-fs5-source-intake-report.json",
      "nextAction": "Generate or review candidate source draft intake; MPC, source-use, reviewer, and composition gates still remain closed.",
      "promotionBoundary": "SBDB refresh supports source-custody intake only. It does not prove composition, resource class, economics, or customer-use clearance.",
      "refreshItemHash": "sha256-db5fe80cca35aa6a56138cce49fdb7b11a31ea7a2ac3d94bb14ba409bf894d49"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-et3",
      "sourceCandidateId": "cad-2026 ET3",
      "designation": "2026 ET3",
      "queueRank": 7,
      "reviewPriorityScore": 25.97,
      "sourceState": "draft-intake-source-ready",
      "hasCadRecord": true,
      "hasSbdbRecord": true,
      "cadRecordHash": "sha256-788fe431205ac32d00cbc4788d2620fde17535e8518978cbfde5489c2835ab6b",
      "sbdbUrl": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+ET3&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
      "cadUrl": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+ET3&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
      "expectedPayloadPath": "evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
      "expectedReportPath": "evidence/source-candidate-reports/2026-et3-source-intake-report.json",
      "nextAction": "Generate or review candidate source draft intake; MPC, source-use, reviewer, and composition gates still remain closed.",
      "promotionBoundary": "SBDB refresh supports source-custody intake only. It does not prove composition, resource class, economics, or customer-use clearance.",
      "refreshItemHash": "sha256-d7f30334c3b5350a37b0a985e9267b714f4c977729e9f681b42e409149c4e5e6"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-jn4",
      "sourceCandidateId": "cad-2026 JN4",
      "designation": "2026 JN4",
      "queueRank": 8,
      "reviewPriorityScore": 24.65,
      "sourceState": "draft-intake-source-ready",
      "hasCadRecord": true,
      "hasSbdbRecord": true,
      "cadRecordHash": "sha256-51d49cdf5f6b9de9f9d2aa878f9d509f49c30331597062946b9d50d0979feb11",
      "sbdbUrl": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+JN4&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
      "cadUrl": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+JN4&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
      "expectedPayloadPath": "evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
      "expectedReportPath": "evidence/source-candidate-reports/2026-jn4-source-intake-report.json",
      "nextAction": "Generate or review candidate source draft intake; MPC, source-use, reviewer, and composition gates still remain closed.",
      "promotionBoundary": "SBDB refresh supports source-custody intake only. It does not prove composition, resource class, economics, or customer-use clearance.",
      "refreshItemHash": "sha256-a616446f72af43cd5adce245c9929a214fcff3f41d3cdf7835e37ff0c45adde6"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-jv3",
      "sourceCandidateId": "cad-2026 JV3",
      "designation": "2026 JV3",
      "queueRank": 9,
      "reviewPriorityScore": 24.51,
      "sourceState": "draft-intake-source-ready",
      "hasCadRecord": true,
      "hasSbdbRecord": true,
      "cadRecordHash": "sha256-1161584710b9400e81369b2561160495bfd69508cf35266401c17270158142ef",
      "sbdbUrl": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+JV3&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
      "cadUrl": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+JV3&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
      "expectedPayloadPath": "evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
      "expectedReportPath": "evidence/source-candidate-reports/2026-jv3-source-intake-report.json",
      "nextAction": "Generate or review candidate source draft intake; MPC, source-use, reviewer, and composition gates still remain closed.",
      "promotionBoundary": "SBDB refresh supports source-custody intake only. It does not prove composition, resource class, economics, or customer-use clearance.",
      "refreshItemHash": "sha256-6ae07e0faca2eeb7cb7d587d9cbea7104f0ee6ea288b4a822a58d23e9a095a53"
    },
    {
      "workOrderId": "small-body-source-work-order-2026-hz4",
      "sourceCandidateId": "cad-2026 HZ4",
      "designation": "2026 HZ4",
      "queueRank": 10,
      "reviewPriorityScore": 24.43,
      "sourceState": "draft-intake-source-ready",
      "hasCadRecord": true,
      "hasSbdbRecord": true,
      "cadRecordHash": "sha256-1f91700c0ef8e7c2ba41cb60178b5b28c180b0bd4181305233922101f2eb92e0",
      "sbdbUrl": "https://ssd-api.jpl.nasa.gov/sbdb.api?sstr=2026+HZ4&phys-par=1&ca-data=1&ca-time=both&ca-unc=1&alt-des=1",
      "cadUrl": "https://ssd-api.jpl.nasa.gov/cad.api?des=2026+HZ4&date-min=2026-01-01&date-max=2026-12-31&dist-max=0.05&diameter=true&fullname=true&sort=dist",
      "expectedPayloadPath": "evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
      "expectedReportPath": "evidence/source-candidate-reports/2026-hz4-source-intake-report.json",
      "nextAction": "Generate or review candidate source draft intake; MPC, source-use, reviewer, and composition gates still remain closed.",
      "promotionBoundary": "SBDB refresh supports source-custody intake only. It does not prove composition, resource class, economics, or customer-use clearance.",
      "refreshItemHash": "sha256-72ab270cf0d69d8119f0f9bbce98e1b304c5f4fcc8576484377a10ad91ab7a5f"
    }
  ],
  "manifestHash": "sha256-c5b0581231f6ca853b76228531f0fa66fe77bf56fcb2d791e809572392a6f3a1"
}
;
